import { yellowAnchor, blueAnchor } from '@model';

const seriesTemplate = {
  borderWidth: 0,
  shadow: false,
};

const SeriesName = {
  point: {
    buyer: 'buyerCoord',
    target: 'targetCoord',
    shared: 'sharedCoord',
  },
};

export const isPointType = (name) =>
  Object.values(SeriesName.point).includes(name);

// const Colors = {
//   ActiveBuyerArea: '#FFB600',
//   InactiveBuyerArea: '#FFECBD',
//   ActiveTargetArea: '#4DACF1',
//   InactiveTargetArea: '#B3DCF9 ',
//   ActiveSharedArea: '#E45C2B',
//   InactiveSharedArea: '#FEB791',
// };
const Colors = {
  ActiveBuyerArea: 'rgb(194, 138, 0)',
  InactiveBuyerArea: '#FFECBD',
  ActiveTargetArea: 'rgb(0, 137, 235)',
  InactiveTargetArea: '#B3DCF9',
  ActiveSharedArea: 'rgb(208, 74, 2)',
  InactiveSharedArea: '#FEB791',
};

const convertInfo = (info) => ({
  code: info?.buyer ? info.buyer.code : info.code,
  others: info,
});

export default class LESeriesOptions {
  constructor({
    buyerName,
    buyerInfo,
    targetName,
    targetInfo,
    sharedInfo,
    buyerLabel,
    targetLabel,
    buyerOffices,
    targetOffices,
    handleMapClickCb,
  }) {
    this.buyerInfo = buyerInfo || [];
    this.buyerName = buyerName || buyerLabel;
    this.targetInfo = targetInfo || [];
    this.targetName = targetName || targetLabel;
    this.sharedInfo = sharedInfo || [];
    this.buyerLocations = buyerOffices || [];
    this.targetLocations = targetOffices || [];
    this.buyerArea = {
      ...seriesTemplate,
      name: buyerLabel,
      data: this.buyerInfo.map(convertInfo),
      allAreas: true,
      events: {
        click: (e) => {
          const { others: companyInfo } = e.point;
          handleMapClickCb(companyInfo.countryName, 0);
        },
      },
    };
    this.targetArea = {
      ...seriesTemplate,
      name: targetLabel,
      data: this.targetInfo.map(convertInfo),
      events: {
        click: (e) => {
          const { others: companyInfo } = e.point;
          handleMapClickCb(companyInfo.countryName, 1);
        },
      },
    };
    this.sharedArea = {
      ...seriesTemplate,
      name: 'Shared',
      data: this.sharedInfo.map(convertInfo),
      events: {
        click(e) {
          const { others: sharedCompanyInfo } = e.point;
          handleMapClickCb(sharedCompanyInfo.buyer.countryName);
        },
      },
    };
    this.buyerPoint = {
      ...seriesTemplate,
      type: 'mappoint',
      name: SeriesName.point.buyer,
      dataLabels: {
        enabled: false,
      },
      marker: {
        symbol: `url(${yellowAnchor})`,
        height: 15,
        width: 12,
      },
      data: this.buyerLocations.map(
        LESeriesOptions.createPointInfo({
          color: Colors.ActiveBuyerArea,
          companyName: this.buyerName,
        }),
      ),
    };
    this.targetPoint = {
      ...seriesTemplate,
      type: 'mappoint',
      name: SeriesName.point.target,
      dataLabels: {
        enabled: false,
      },
      marker: {
        symbol: `url(${blueAnchor})`,
        height: 15,
        width: 12,
      },
      data: this.targetLocations.map(
        LESeriesOptions.createPointInfo({
          color: Colors.ActiveTargetArea,
          companyName: this.targetName,
        }),
      ),
    };
  }

  static createPointInfo(payload) {
    return ({ latitude, longitude, ...others }) => ({
      lat: latitude,
      lon: longitude,
      others: { ...payload, ...others },
    });
  }

  fillInColors() {
    if (this.buyerLocations.length > 0) {
      this.buyerArea.color = Colors.InactiveBuyerArea;
    } else {
      this.buyerArea.color = Colors.ActiveBuyerArea;
    }
    if (this.targetLocations.length > 0) {
      this.targetArea.color = Colors.InactiveTargetArea;
    } else {
      this.targetArea.color = Colors.ActiveTargetArea;
    }
    if (this.targetLocations.length + this.buyerLocations.length > 0) {
      this.sharedArea.color = Colors.InactiveSharedArea;
    } else {
      this.sharedArea.color = Colors.ActiveSharedArea;
    }
  }

  getOptions() {
    this.fillInColors();
    return [
      this.buyerArea,
      this.targetArea,
      this.sharedArea,
      this.buyerPoint,
      this.targetPoint,
    ];
  }
}
